export default {
  primary: '#b69a70',
  secondary: '#203f39',
  accent: '#009688',
  error: '#ff3547',
  info: '#33b5e5',
  success: '#00c851',
  warning: '#fb3',
};
